import { TabBar } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { TimetableBuildingsTable } from '../../../../components/Buildings/Tables/TimetableBuildingsTable';
import { Page } from '../../../../components/Page/Page';
import { RoomsTable } from '../../../../components/Rooms/Tables/RoomsTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const SetupRoomsAndBuildings = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadTimetable()}>
      <TabBar
        variant={'large'}
        tabs={[
          {
            trigger: t('rooms.title', { count: 2 }),
            id: 'rooms',
            content: <RoomsTable />,
          },
          {
            trigger: t('buildings.title', { count: 2 }),
            id: 'buildings',
            content: <TimetableBuildingsTable />,
          },
        ]}
      />
    </Page>
  );
};
